import { mapActions } from "vuex";
import { GET_BROKER_SUBSCRIPTION } from '@/store/actions.type'
import moment from 'moment'
import {CSVExport} from '../../mixins/CSVExport'
import { param } from "jquery";
// import { data } from "jquery";
export default {
  mixins: [CSVExport],
  data() {
    return {
      currentPage: 1,
      failureCurrentPage: 1,
      elementsPerPage: 20,
      ascending: false,
      sortColumn: '',
      successfullTransactionList: [],
      faliureTransactionsList: [],
      maxDate: moment().format("YYYY-MM-DD"),
      minDate: "1900-09-05",
      successColumns: ['SNo', 'Name', 'Email', 'PhoneNumber', 'ClientCode', 'TransactionId', 'Amount', 'PremiumAccess', 'PurchaseDate', 'Promo'],
      failureColumns: ['SNo', 'Name', 'Email', 'PhoneNumber', 'ClientCode', 'Amount', 'RequestedDate'],
      totalToday: '0',
      totalmonthly: '0',
      filters: ['All', 'Last 7 days', 'Last 30 days', 'Custom'],
      selectedValue: null,
      showTransactions: false
    }
  },

  computed: {
    userData() {
      return this.$store.state.authentication.user;
    },
  },

  created() {
    // if(this.userData.isBrokerUser)
    // 	this.$router.replace('/evaluation/');
    // else
  },

  methods: {
    ...mapActions({
      getBrokerTransactionDetails: GET_BROKER_SUBSCRIPTION
    }),

    async fetchBrokerTransactionDetails() {
      if (this.selectedValue != null) {
        let params = this.getparams();

        await this.getBrokerTransactionDetails(params).then(data => {
          this.totalmonthly = data.totalMonthly != null ? data.totalMonthly : '0.00'
          this.totalToday = data.totalToday != null ? data.totalToday : '0.00'
          this.showTransactions = true
          if (data.successfullTransaction != null || data.faliureTransaction != null) {
            this.successfullTransactionList = data.successfullTransaction
            this.faliureTransactionsList = data.failureTransaction
          }
          else {
            alert("No transaction")
          }
        })
      }
      else {
        alert("Please select date range to see the transactions")
      }
    },
    exportToCSV (type) {
      let csvContent = '';
      var fileName = '';
      if(type === 'success') {
        fileName = "Success_Transactions.csv";
        csvContent = "SNo, Name, Email, PhoneNumber, ClientCode, TransactionId, Amount, PremiumAccess, PurchaseDate, Promo\n";
        csvContent += [...(this.successfullTransactionList).map(item => Object.values(item).join(","))].join("\n").replace(/(^\[)|(\]$)/gm, "");
      } else {
        fileName = "Failed_Transactions.csv";
        csvContent = "SNo, Name, Email, PhoneNumber, ClientCode, Amount, RequestedDate\n";
        csvContent += [...(this.faliureTransactionsList).map(item => Object.values(item).join(","))].join("\n").replace(/(^\[)|(\]$)/gm, "");
      }
      CSVExport.exportCSV(csvContent, fileName)
    },
    getparams() {
      let params = {
        "fromDate": '',
        "toDate": '',
        "userType": this.getBrokerUserType(this.userData.userType, this.userData.isBrokerAdminUser)
      }

      switch (this.selectedValue) {
        case 'All':
          var curr = new Date;
          var fromdate = '1997-01-01'
          var todate = moment(String(curr)).format('YYYY-MM-DD')
          params.fromDate = fromdate
          params.toDate = todate
          return params;

        case 'Last 7 days':
          var curr = new Date; // get current date
          var lastweek = moment().subtract(6, 'd').toDate();
          var fromdate = moment(String(lastweek)).format('YYYY-MM-DD')
          var todate = moment(String(curr)).format('YYYY-MM-DD')
          params.fromDate = fromdate
          params.toDate = todate

          return params;

        case 'Last 30 days':
          var curr = new Date; // get current date
          var lastmonth = moment().subtract(29, 'd').toDate();
          var fromdate = moment(String(lastmonth)).format('YYYY-MM-DD')
          var todate = moment(String(curr)).format('YYYY-MM-DD')
          params.fromDate = fromdate
          params.toDate = todate
          return params;

        case 'Custom':
          params.fromDate = fromdatePickerId.value
          params.toDate = todatePickerId.value
          return params;

        default:
          return params
      }
    },

    async getTransactions() {
      this.fetchBrokerTransactionDetails()
    },

    sortTable: function sortTable(col) {
      if (this.sortColumn === col) {
        this.ascending = !this.ascending;
      } else {
        this.ascending = true;
        this.sortColumn = col;
      }

      var ascending = this.ascending;

      this.successfullTransactionList.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0;
      })
    },

    get_rows_forSuccessTransaction: function get_rows_forSuccessTransaction() {
      var start = (this.currentPage - 1) * this.elementsPerPage;
      var end = start + this.elementsPerPage;
      return this.successfullTransactionList.slice(start, end);
    },
    get_rows_forFailTransaction: function get_rows_forFailTransaction() {
      var start = (this.failureCurrentPage - 1) * this.elementsPerPage;
      var end = start + this.elementsPerPage;
      return this.faliureTransactionsList.slice(start, end);
    },

    selectPeriod(event) {
      this.selectedValue = event.target.options[event.target.options.selectedIndex].text
    },

    getBrokerUserType(userBrokerType, isAdmin) {
      var userType = 1
      if (userBrokerType == 2 && isAdmin) {
        userType = 2 // for anand rathi broker
      }

      return userType
  }

  }
}



// WEBPACK FOOTER //
// ./src/assets/js/PartnerBrokerDashboard.js